import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import ToggleComponent from "../../../containers/Common/ToggleComponent";
import DropdownComponent from "../../../containers/Dropdown";
import TimePicker from "rc-time-picker";
import * as utilities from "../../../utilities/utils";
import moment from "moment";
import add from "../../../images/add.svg";
import ManagerDetailModal from "../../Std/ManagerDetailModal.jsx";

import {
  TYPEOFCLAIMDRPDATA,
  EMPLOYEESTATUSDRPDATA,
  format,
  WORKSHIFTDRPDATA,
  PHONE_PLACEHOLDER,
  PROVINCEDRPDATA,
  COUNTRYDRPDATA,
  MODAL_SIZE,
  RegularWorkSchedule,
  WORKSHIFTDRPDATA_FR,
  EMPLOYEESTATUSDRPDATA_FR,
  CLAIMTYPE,
  CLAIMTYPE_FR,
  TYPEOFCLAIMDRPDATA_FR
} from "../../../App.config";
import "rc-time-picker/assets/index.css";
import "react-datepicker/dist/react-datepicker.css";
import Compensation from "../../../images/Compensation.svg";
import backArrow from "../../../images/back-arrow.svg";
import CustomDatePicker from "../../../containers/Common/CustomDatePicker";
import DisplayEmployeeBlock from "../DisplayEmployeeBlock";

let accidentInvestigationQuestion = [
  // {
  //   questionNo: 2,
  //   name: "accidentQues2",
  //   commentFieldName: "accidentQues2Comment",
  //   question: "AIR-Accident-Information.form.label.text.Que2",
  //   displayOrder: 3
  // },
  {
    questionNo: 3,
    name: "accidentQues3",
    commentFieldName: "accidentQues3Comment",
    question: "AIR-Accident-Information.form.label.text.Que3",
    displayOrder: 4
  },
  {
    questionNo: 4,
    name: "accidentQues4",
    commentFieldName: "accidentQues4Comment",
    question: "AIR-Accident-Information.form.label.text.Que4",
    displayOrder: 6
  },
  {
    questionNo: 5,
    name: "accidentQues5",
    commentFieldName: "accidentQues5Comment",
    question: "AIR-Accident-Information.form.label.text.Que5",
    displayOrder: 8
  },
  // {
  //   questionNo: 6,
  //   name: "accidentQues6",
  //   commentFieldName: "accidentQues6Comment",
  //   question: "AIR-Accident-Information.form.label.text.Que6",
  //   displayOrder: 9
  // },
  {
    questionNo: 7,
    name: "accidentQues7",
    commentFieldName: "accidentQues7Comment",
    question: "AIR-Accident-Information.form.label.text.Que7",
    displayOrder: 10
  },
  {
    questionNo: 8,
    name: "accidentQues8",
    commentFieldName: "accidentQues8Comment",
    question: "AIR-Accident-Information.form.label.text.Que8",
    displayOrder: 11
  },
  {
    questionNo: 9,
    name: "accidentQues9",
    commentFieldName: "accidentQues9Comment",
    question: "AIR-Accident-Information.form.label.text.Que9",
    displayOrder: 5
  },
  // {
  //   questionNo: 10,
  //   name: "accidentQues10",
  //   commentFieldName: "accidentQues10Comment",
  //   question: "AIR-Accident-Information.form.label.text.Que10",
  //   displayOrder: 7
  // },
  {
    questionNo: 11,
    name: "accidentQues11",
    commentFieldName: "accidentQues11Comment",
    question: "AIR-Accident-Information.form.label.text.Que11",
    displayOrder: 2
  },
];

accidentInvestigationQuestion = accidentInvestigationQuestion.sort((a, b) => a.displayOrder > b.displayOrder ? 1 : ((b.displayOrder > a.displayOrder) ? -1 : 0))

const AccidentInformation = ({
  state,
  previousStep,
  handleChanges,
  hideComponent,
  onDateChange,
  handlePhoneNumber,
  props,
  onSubmit,
  onTimeChange,
  onDropDownChange,
  handleQuestionChange,
  handleWeekShift
}) => {

  const chooseDrpLang = () => {
    let defaultLang = WORKSHIFTDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultLang = WORKSHIFTDRPDATA;
    } else {
      defaultLang = WORKSHIFTDRPDATA_FR;
    }

    return defaultLang;
  };

  const decideClaimLngDrp = () => {
    let defaultLang = TYPEOFCLAIMDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultLang = TYPEOFCLAIMDRPDATA;
    } else {
      defaultLang = TYPEOFCLAIMDRPDATA_FR;
    }

    return defaultLang;
  };

  const chooseEmpStatusDrpLang = () => {
    let defaultLang = EMPLOYEESTATUSDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultLang = EMPLOYEESTATUSDRPDATA;
    } else {
      defaultLang = EMPLOYEESTATUSDRPDATA_FR;
    }

    return defaultLang;
  };

  const onAddManager = () => {
    props.openSetModalAction(
      <ManagerDetailModal
        {...props}
      // jobID={state.jobTitle.value}
      // locationID={state.location.value}

      />,
      MODAL_SIZE.MODAL_SM
    );
  };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Panel-header">
              <img
                tabIndex="-1"
                className="btn btn-back"
                onClick={previousStep}
                src={backArrow}
                alt="back-arrow"
              />
              <div className="p-img">
                <img src={Compensation} alt="" />
              </div>
              <h2>
                <span>
                  {props.context.t(
                    "AIR-Accident-Information.form.heading.text"
                  )}
                </span>
              </h2>
            </div>
            <div className="panel-content">
            <DisplayEmployeeBlock context={props.context} state={state} />
              <div className="Custom-form">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.TypeOfClaim"
                        )}
                      </label>
                      <span size="5" className="error-star">
                        *
                      </span>
                      <div className="Custom-select">
                        <DropdownComponent
                          name="typeCliam"
                          options={decideClaimLngDrp()}
                          isMultiSelect={false}
                          option_key="claimId"
                          option_display="claimName"
                          onChange={onDropDownChange}
                          values={state.typeCliam.value}
                          simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                          selectAllText="Select All Options"
                          isSearchOption={true}
                          searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          ref={state.typeCliam.ref}
                        />
                        {state.typeCliam?.error && (
                          <span className="error">{state.typeCliam.error}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 Date-feild">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.DateOfAccident"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {/* (MM/DD/YY) */}
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="dateOfAccident"
                        selected={state.dateOfAccident.value && state.dateOfAccident.value}
                        onChange={(e) => {
                          onDateChange(e, "dateOfAccident");
                        }}
                        maxDate={moment().toDate()}
                        className="form-control"
                        placeholderText={props.context.t(
                          "AIR-Employer-Information.form.common.DateFormat"
                        )}
                        ref={state.dateOfAccident.ref}
                      />
                      {state.dateOfAccident?.error && (
                        <span className="error">
                          {state.dateOfAccident.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Time"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        // placeholder={props.context.t(
                        //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        // )}
                        placeholder="00:00"
                        name="timeOfAccident"
                        value={state.timeOfAccident.value}
                        ref={state.timeOfAccident.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.timeOfAccident?.error && (
                        <span className="error">
                          {state.timeOfAccident.error}
                        </span>
                      )}
                      <small>
                        {/* {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.File-Format"
                          )} */}
                        <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                      </small>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="form-group Ctm-rdo d-block">
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOfAccidentRadio"
                            id="timeOfAccidentRadio-AM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="AM"
                            checked={
                              state.timeOfAccidentRadio.value === "AM"
                            }
                          />
                          <label htmlFor="timeOfAccidentRadio-AM">
                            AM
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOfAccidentRadio"
                            id="timeOfAccidentRadio-PM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="PM"
                            checked={
                              state.timeOfAccidentRadio.value === "PM"
                            }
                          />
                          <label htmlFor="timeOfAccidentRadio-PM">
                            PM
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-12">
                    <div className="form-group">
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.TimeWorkBegan"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <div className="row">
                            <div className="col-8 col-sm-12 col-md-8 col-lg-8">

                              <input
                                type="text"
                                // placeholder={props.context.t(
                                //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                // )}
                                placeholder="00:00"
                                name="timeOfEmployeeWorkBegan"
                                value={state.timeOfEmployeeWorkBegan.value}
                                ref={state.timeOfEmployeeWorkBegan.ref}
                                onChange={handleChanges}
                                className="form-control"
                              />
                              {state.timeOfEmployeeWorkBegan?.error && (
                                <span className="error">
                                  {state.timeOfEmployeeWorkBegan.error}
                                </span>
                              )}
                              <small>

                                <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                              </small>
                            </div>

                            <div className="col-4 col-sm-12 col-md-4 col-lg-4">
                              <div className="form-group Ctm-rdo d-block">

                                <div className="Radio-box" data-toggle="buttons">
                                  <div className="check-col">
                                    <input
                                      type="radio"
                                      name="timeOfEmployeeWorkBeganRadio"
                                      id="timeOfEmployeeWorkBeganRadio-AM"
                                      autoComplete="off"
                                      onChange={handleChanges}
                                      value="AM"
                                      checked={
                                        state.timeOfEmployeeWorkBeganRadio.value === "AM"
                                      }
                                    />
                                    <label htmlFor="timeOfEmployeeWorkBeganRadio-AM">
                                      {/* {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.Yes"
                            )} */}
                                      AM
                                    </label>
                                  </div>
                                  <div className="check-col">
                                    <input
                                      type="radio"
                                      name="timeOfEmployeeWorkBeganRadio"
                                      id="timeOfEmployeeWorkBeganRadio-PM"
                                      autoComplete="off"
                                      onChange={handleChanges}
                                      value="PM"
                                      checked={
                                        state.timeOfEmployeeWorkBeganRadio.value === "PM"
                                      }
                                    />
                                    <label htmlFor="timeOfEmployeeWorkBeganRadio-PM">
                                      {/* {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.No"
                            )} */}
                                      PM
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />

                          </div>

                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.TimeWorkEnd"
                            )}
                            <span size="5" className="error-star">
                              *
                            </span>
                          </label>
                          <div className="row">
                            <div className="col-8 col-sm-12 col-md-8 col-lg-8">
                              {/* <TimePicker
                          name="timeOfEmployeeWorkEnd"
                          value={state.timeOfEmployeeWorkEnd.value}
                          showSecond={false}
                          className="timepicker"
                          onChange={(e) => {
                            onTimeChange("timeOfEmployeeWorkEnd", e);
                          }}
                          ref={state.timeOfEmployeeWorkEnd.ref}
                          format={format}
                          use12Hours
                          inputReadOnly
                          placeholder="Select time"
                        />
                        <br />
                        {state.timeOfEmployeeWorkEnd?.error && (
                          <span className="error">
                            {state.timeOfEmployeeWorkEnd.error}
                          </span>
                        )} */}
                              <input
                                type="text"
                                // placeholder={props.context.t(
                                //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                // )}
                                placeholder="00:00"
                                name="timeOfEmployeeWorkEnd"
                                value={state.timeOfEmployeeWorkEnd.value}
                                ref={state.timeOfEmployeeWorkEnd.ref}
                                onChange={handleChanges}
                                className="form-control"
                              />
                              {state.timeOfEmployeeWorkEnd?.error && (
                                <span className="error">
                                  {state.timeOfEmployeeWorkEnd.error}
                                </span>
                              )}
                              <small>
                                {/* {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.File-Format"
                          )} */}
                                <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                              </small>
                            </div>
                            <div className="col-4 col-sm-12 col-md-4 col-lg-4">
                              <div className="form-group Ctm-rdo d-block">
                                {/* <label htmlFor="">
                                {props.context.t(
                          "AIR-Accident-Information.form.label.text.IsFirstAidGiven"
                        )}
                              </label> */}
                                <div className="Radio-box" data-toggle="buttons">
                                  <div className="check-col">
                                    <input
                                      type="radio"
                                      name="timeOfEmployeeWorkEndRadio"
                                      id="timeOfEmployeeWorkEndRadio-AM"
                                      autoComplete="off"
                                      onChange={handleChanges}
                                      value="AM"
                                      checked={
                                        state.timeOfEmployeeWorkEndRadio.value === "AM"
                                      }
                                    />
                                    <label htmlFor="timeOfEmployeeWorkEndRadio-AM">
                                      {/* {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.Yes"
                            )} */}
                                      AM
                                    </label>
                                  </div>
                                  <div className="check-col">
                                    <input
                                      type="radio"
                                      name="timeOfEmployeeWorkEndRadio"
                                      id="timeOfEmployeeWorkEndRadio-PM"
                                      autoComplete="off"
                                      onChange={handleChanges}
                                      value="PM"
                                      checked={
                                        state.timeOfEmployeeWorkEndRadio.value === "PM"
                                      }
                                    />
                                    <label htmlFor="timeOfEmployeeWorkEndRadio-PM">
                                      {/* {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.No"
                            )} */}
                                      PM
                                    </label>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 Date-feild">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.DateOnsetSymptoms"
                        )}
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="dateOnsetSymptoms"
                        selected={state.dateOnsetSymptoms.value && state.dateOnsetSymptoms.value}
                        onChange={(e) => {
                          onDateChange(e, "dateOnsetSymptoms");
                        }}
                        ref={state.dateOnsetSymptoms.ref}
                        maxDate={moment().toDate()}
                        className="form-control"
                        placeholderText={props.context.t(
                          "AIR-Employer-Information.form.common.DateFormat"
                        )}
                      />
                      {state.dateOnsetSymptoms?.error && (
                        <span className="error">
                          {state.dateOnsetSymptoms.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Time"
                        )}
                      </label>
                      <input
                        type="text"

                        placeholder="00:00"
                        name="timeOnsetSymptoms"
                        value={state.timeOnsetSymptoms.value}
                        ref={state.timeOnsetSymptoms.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      <small>

                        {props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}
                      </small>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="form-group Ctm-rdo d-block">

                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOnsetSymptomsRadio"
                            id="timeOnsetSymptomsRadio-AM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="AM"
                            checked={
                              state.timeOnsetSymptomsRadio.value === "AM"
                            }
                          />
                          <label htmlFor="timeOnsetSymptomsRadio-AM">
                            AM
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOnsetSymptomsRadio"
                            id="timeOnsetSymptomsRadio-PM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="PM"
                            checked={
                              state.timeOnsetSymptomsRadio.value === "PM"
                            }
                          />
                          <label htmlFor="timeOnsetSymptomsRadio-PM">
                            PM
                          </label>
                        </div>
                        {state.timeOnsetSymptoms?.error && (
                          <span className="error">
                            {state.timeOnsetSymptoms.error}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  <div className="col-12 col-sm-6 col-md-6 col-lg-6 Date-feild">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.DateReported"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                        {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                      </label>
                      <CustomDatePicker
                        id="dateOfReported"
                        selected={state.dateOfReported.value && state.dateOfReported.value}
                        onChange={(e) => {
                          onDateChange(e, "dateOfReported");
                        }}
                        maxDate={moment().toDate()}
                        ref={state.dateOfReported.ref}
                        className="form-control"
                        placeholderText={props.context.t(
                          "AIR-Employer-Information.form.common.DateFormat"
                        )}
                      />
                      {state.dateOfReported?.error && (
                        <span className="error">
                          {state.dateOfReported.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-3 col-md-3 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Time"
                        )}
                      </label>
                      <span size="5" className="error-star">
                        *
                      </span>
                      <input
                        type="text"
                        // placeholder={props.context.t(
                        //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        // )}
                        placeholder="00:00"
                        name="timeOfReported"
                        value={state.timeOfReported.value}
                        ref={state.timeOfReported.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                      {state.timeOfReported?.error && (
                        <span className="error">
                          {state.timeOfReported.error}
                        </span>
                      )}
                      <small>
                        {/* {props.context.t(
                            "STD-Employer-Statement.form.Employer-Details.label.text.File-Format"
                          )} */}
                        <p>{props.context.t("AIR-Accident-Information.form.label.text.12HourFormat")}</p>
                      </small>
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="form-group Ctm-rdo d-block">

                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOfReportedRadio"
                            id="timeOfReportedRadio-AM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="AM"
                            checked={
                              state.timeOfReportedRadio.value === "AM"
                            }
                          />
                          <label htmlFor="timeOfReportedRadio-AM">

                            AM
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="timeOfReportedRadio"
                            id="timeOfReportedRadio-PM"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="PM"
                            checked={
                              state.timeOfReportedRadio.value === "PM"
                            }
                          />
                          <label htmlFor="timeOfReportedRadio-PM">

                            PM
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">


                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.AddressOfRWL"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <textarea
                        type="textarea"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="addressOfRWL"
                        value={state.addressOfRWL.value}
                        ref={state.addressOfRWL.ref}
                        onChange={handleChanges}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>



                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                      <ul>
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.RegularWorkSchdule"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <li className="Custom-check-box">
                          {state.weekWDH.value.length
                            ? state.weekWDH.value.map((day) => (
                              <div key={day.shift} className="check-col">
                                <label htmlFor="By-Last-Name">
                                  {props.context.t("ACCOMODATION-Employer-Information.form.Employee-Details.label.text." + day.name)}
                                </label>
                                <div>
                                  <div className="form-group">
                                    <label htmlFor="">&nbsp;</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name={day.name}
                                      value={day.hours}
                                      onChange={handleWeekShift}
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                              </div>
                            ))
                            : null}
                        </li>
                      </ul>
                    </div>

                  </div>

                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo mb-0">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.DoestheEmployeeWorkShift"
                        )}
                      </label>
                      <ToggleComponent
                        name="doesWorkShift"
                        isActive={state.doesWorkShift.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                  </div>
                </div>


                <div className="row">
                  {state.doesWorkShift.value === "Yes" ? (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                      <DropdownComponent
                        name="workShift"
                        options={chooseDrpLang()}
                        isMultiSelect={false}
                        option_key="shiftId"
                        option_display="shiftName"
                        onChange={onDropDownChange}
                        values={state.workShift.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      />
                    </div>
                  ) : null}
                  {(utilities.extractFirstValueOfArray(state.workShift.value) ===
                    "Other" && state.doesWorkShift.value == "Yes") ? (
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                      <div className="form-group">

                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="doesWorkShiftExtra"
                          value={state.doesWorkShiftExtra.value}
                          ref={state.doesWorkShiftExtra.ref}
                          onChange={handleChanges}
                          className="form-control"
                        />
                        {state.doesWorkShiftExtra?.error && (
                          <span className="error">
                            {state.doesWorkShiftExtra.error}
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="row mg-top-20">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.TypeOfEmployement"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <DropdownComponent
                        name="typeOfEmployment"
                        options={chooseEmpStatusDrpLang()}
                        isMultiSelect={false}
                        option_key="employmentStatusId"
                        option_display="employmentStatusName"
                        onChange={onDropDownChange}
                        values={state.typeOfEmployment.value}
                        simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                        selectAllText="Select All Options"
                        isSearchOption={true}
                        searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        ref={state.typeOfEmployment.ref}
                      />
                      {state.typeOfEmployment?.error && (
                        <span className="error">
                          {state.typeOfEmployment.error}
                        </span>
                      )}
                    </div>
                  </div>
                  {utilities.extractFirstValueOfArray(
                    state.typeOfEmployment.value
                  ) === "Other" ? (
                    <div className="col-12 col-sm-12 col-md-12 col-lg">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.TypeOfEmployementOther"
                          )}
                          {/* Type of Employment:
                          <span size="5" className="error-star">
                            *
                          </span> */}
                        </label>
                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          className="form-control"
                          name="typeOfEmploymentExtra"
                          value={state.typeOfEmploymentExtra.value}
                          onChange={handleChanges}
                          ref={state.typeOfEmploymentExtra.ref}
                        />
                        {state.typeOfEmploymentExtra?.error && (
                          <span className="error">
                            {state.typeOfEmploymentExtra.error}
                          </span>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>

                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "AIR-Accident-Information.form.label.text.NLTtitle"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.PayRate"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text input-group-prepend-front">
                            $
                          </div>
                        </div>
                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="payrate"
                          value={state.payrate.value}
                          ref={state.payrate.ref}
                          onChange={handleChanges}
                          className="form-control"
                        />
                        <div className="input-group-prepend">
                          <div className="input-group-text input-group-prepend-back">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.per"
                            )}
                          </div>
                        </div>
                      </div>
                      {state.payrate?.error && (
                        <span className="error">{state.payrate.error}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-5">
                    <div className="form-group">
                      <label htmlFor=""></label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="payPer"
                            id="payrate-hour"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="hour"
                            checked={state.payPer.value === "hour"}
                          />
                          <label htmlFor="payrate-hour">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.PayRate.option-hour"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="payPer"
                            id="payrate-week"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="week"
                            checked={state.payPer.value === "week"}
                          />
                          <label htmlFor="payrate-week">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.PayRate.option-week"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="payPer"
                            id="payrate-day"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="day"
                            checked={state.payPer.value === "day"}
                          />
                          <label htmlFor="payrate-day">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.PayRate.option-day"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="payPer"
                            id="payrate-other"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="other"
                            checked={state.payPer.value === "other"}
                          />
                          <label htmlFor="payrate-other">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.PayRate.option-other"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.payPer.value === "other" &&
                    <div className="col-12 col-sm-12 col-md-6 col-lg-3">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.other"
                          )}
                          {/* <span size="5" className="error-star">
                          *
                        </span> */}
                        </label>
                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="payOther"
                          value={state.payOther.value}
                          onChange={handleChanges}
                          className="form-control"
                        />
                      </div>
                    </div>
                  }
                </div>
                <div className="row">

                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.FourWeeksPriorInfo"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="fourWeeksPriorEarningnfo"
                        value={state.fourWeeksPriorEarningnfo.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.ShiftPremium"
                        )}
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <div className="input-group-text input-group-prepend-front">
                            $
                          </div>
                        </div>
                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="shiftPremium"
                          ref={state.shiftPremium.ref}
                          value={state.shiftPremium.value}
                          onChange={handleChanges}
                          className="form-control"
                        />
                      </div>
                      {state.shiftPremium?.error && (
                        <span className="error">
                          {state.shiftPremium.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* New Change */}
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.ThreeMonthsWeeksPriorInfo"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="ThreeMonPriorEarningnfo"
                        value={state.ThreeMonPriorEarningnfo.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.TwelWeeksPriorInfo"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="TwelMonthPriorEarningnfo"
                        value={state.TwelMonthPriorEarningnfo.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.OvertimeToInjury"
                        )}
                        {/* <span size="5" className="error-star">
                          *
                        </span> */}
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="overtimeToInjury"
                        value={state.overtimeToInjury.value}
                        onChange={handleChanges}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group Ctm-rdo d-block">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.OvertimeToInjuryType"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="overtimeToInjuryType"
                            id="overtimeToInjuryType-Mandatory"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Mandatory"
                            checked={
                              state.overtimeToInjuryType.value === "Mandatory"
                            }
                          />
                          <label htmlFor="overtimeToInjuryType-Mandatory">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.OvertimeToInjuryType.Mandatory"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="overtimeToInjuryType"
                            id="overtimeToInjuryType-Voluntary"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Voluntary"
                            checked={
                              state.overtimeToInjuryType.value === "Voluntary"
                            }
                          />
                          <label htmlFor="overtimeToInjuryType-Voluntary">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.OvertimeToInjuryType.Voluntary"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="overtimeToInjuryType"
                            id="overtimeToInjuryType-NA"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="NA"
                            checked={
                              state.overtimeToInjuryType.value === "NA"
                            }
                          />
                          <label htmlFor="overtimeToInjuryType-NA">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.OvertimeToInjuryType.NA"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "AIR-Accident-Information.form.label.text.AccidentTitle"
                    )}
                  </span>
                </h2>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group">
                      <ul>
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.AccidentTitle"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                        </label>
                        <div className="Radio-box" data-toggle="buttons">
                          <div className="check-col">
                            <input
                              type="radio"
                              name="accidentReported"
                              id="accidentReported-Myself"
                              autoComplete="off"
                              onChange={handleQuestionChange}
                              value="Myself"
                              checked={
                                state.accidentReported.value === "Myself"
                              }
                            />
                            <label htmlFor="accidentReported-Myself">
                              {props.context.t(
                                "AIR-Accident-Information.form.label.text.AccidentReported.Myself"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              name="accidentReported"
                              id="accidentReported-Manager"
                              autoComplete="off"
                              onChange={handleQuestionChange}
                              value="Manager"
                              checked={
                                state.accidentReported.value === "Manager"
                              }
                            />
                            <label htmlFor="accidentReported-Manager">
                              {props.context.t(
                                "AIR-Accident-Information.form.label.text.AccidentReported.Manager"
                              )}
                            </label>
                          </div>
                          <div className="check-col">
                            <input
                              type="radio"
                              name="accidentReported"
                              id="accidentReported-Other"
                              autoComplete="off"
                              onChange={handleQuestionChange}
                              value="Other"
                              checked={
                                state.accidentReported.value === "Other"
                              }
                            />
                            <label htmlFor="accidentReported-Other">
                              {props.context.t(
                                "AIR-Accident-Information.form.label.text.AccidentReported.Other"
                              )}
                            </label>
                          </div>
                        </div>
                      </ul>
                    </div>

                  </div>
                  {(state.accidentReported.value === "Manager" || state.accidentReported.value === "Other") && props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature && state.showManager &&
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.AccidentReported.Manager"
                          )}
                        </label>
                        <div className="Custom-select">
                          {props.supervisorList && (
                            <DropdownComponent
                              name="accidentReportedManager"
                              id="accidentReportedManager"
                              options={props.supervisorList}
                              isMultiSelect={false}
                              option_key="supervisorID_PK"
                              option_display="fullNameWithEmail"//"primaryName"
                              onChange={onDropDownChange}
                              values={state.accidentReportedManager.value}
                              simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                              selectAllText="Select All Options"
                              isSearchOption={true}
                              searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                              ref={state.accidentReportedManager.ref}
                            />
                          )}
                          {state.accidentReportedManager?.error && (
                            <span className="error">
                              {state.accidentReportedManager.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  }
                  {/* {state.accidentReported.value === "Manager" && state.showManager &&
                    <div className="col-1 col-sm-1 col-md-1 col-lg-1">
                      <div className="form-group margin-top-30">
                        <a onClick={onAddManager} className="btn">
                          <img src={add} />
                        </a>
                      </div>
                    </div>
                  } */}
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Name"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="nameOfWhomReported"
                        value={state.nameOfWhomReported.value}
                        onChange={handleChanges}
                        ref={state.nameOfWhomReported.ref}
                        className="form-control"
                        readOnly={!state.nameOfWhomReported.isEditable}
                      />
                      {state.nameOfWhomReported?.error && (
                        <span className="error">
                          {state.nameOfWhomReported.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Position"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        name="positionOfWhomReported"
                        value={state.positionOfWhomReported.value}
                        onChange={handleChanges}
                        ref={state.positionOfWhomReported.ref}
                        className="form-control"
                        readOnly={!state.positionOfWhomReported.isEditable}
                      />
                      {state.positionOfWhomReported?.error && (
                        <span className="error">
                          {state.positionOfWhomReported.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Telephone"
                        )}
                        <span size="5" className="error-star">
                          *
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder={PHONE_PLACEHOLDER}
                        name="telephoneOfWhomReported"
                        value={state.telephoneOfWhomReported.value}
                        onChange={handlePhoneNumber}
                        ref={state.telephoneOfWhomReported.ref}
                        maxLength="14"
                        className="form-control"
                        readOnly={!state.telephoneOfWhomReported.isEditable}
                      />
                      {state.telephoneOfWhomReported?.error && (
                        <span className="error">
                          {state.telephoneOfWhomReported.error}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                    <div className="form-group">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Ext"
                        )}
                      </label>
                      <input
                        type="text"
                        name="ExtOfWhomReported"
                        value={state.ExtOfWhomReported.value}
                        onChange={handleChanges}
                        ref={state.ExtOfWhomReported.ref}
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        maxLength="14"
                        className="form-control"
                        readOnly={!state.ExtOfWhomReported.isEditable}
                      />
                      {state.ExtOfWhomReported?.error && (
                        <span className="error">
                          {state.ExtOfWhomReported.error}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-auto">
                    <div className="form-group Ctm-rdo d-block">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.IsFirstAidGiven"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="isFirstAidGiven"
                            id="firstAid-Yes"
                            autoComplete="off"
                            onChange={handleQuestionChange}
                            value="Yes"
                            checked={
                              state.isFirstAidGiven.value === "Yes"
                            }
                          />
                          <label htmlFor="firstAid-Yes">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.Yes"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="isFirstAidGiven"
                            id="firstAid-No"
                            autoComplete="off"
                            onChange={handleQuestionChange}
                            value="No"
                            checked={
                              state.isFirstAidGiven.value === "No"
                            }
                          />
                          <label htmlFor="firstAid-No">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.IsFirstAidGiven.No"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {state.isFirstAidGiven.value === "Yes" && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg">
                      <div className="form-group Date-feild">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.DateofFirstAidGiven"
                          )}
                          <span size="5" className="error-star">
                            *
                          </span>
                          {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                        </label>

                        <CustomDatePicker
                          id="dateOfFirstAidGiven"
                          selected={state.dateOfFirstAidGiven.value && state.dateOfFirstAidGiven.value}
                          onChange={(e) => {
                            onDateChange(e, "dateOfFirstAidGiven");
                          }}
                          name="dateOfFirstAidGiven"
                          className="form-control"
                          maxDate={moment().toDate()}
                          placeholderText={props.context.t(
                            "AIR-Employer-Information.form.common.DateFormat"
                          )}
                          ref={state.dateOfFirstAidGiven.ref}
                        />
                        {state.dateOfFirstAidGiven?.error && (
                          <span className="error">
                            {state.dateOfFirstAidGiven.error}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                  {state.isFirstAidGiven.value === "Yes" && (
                    <div className="col-12 col-sm-12 col-md-12 col-lg">
                      <div className="form-group">
                        <label htmlFor="">
                          {props.context.t(
                            "AIR-Accident-Information.form.label.text.FirstAidAttendantName"
                          )}
                        </label>
                        <input
                          type="text"
                          placeholder={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                          )}
                          name="firstAidAttendantName"
                          value={state.firstAidAttendantName.value}
                          onChange={handleChanges}
                          ref={state.firstAidAttendantName.ref}
                          className="form-control"
                        />
                        {state.firstAidAttendantName?.error && (
                          <span className="error">{state.firstAidAttendantName.error}</span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.Didtheemployeereceivehealthcare"
                        )}
                      </label>
                      <ToggleComponent
                        name="didHealthcareReceived"
                        isActive={state.didHealthcareReceived.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleChanges}
                      />
                    </div>
                  </div>
                </div>


                {state.didHealthcareReceived.value == "Yes" &&
                  <div>
                    <h2 className="Sub-Heading">
                      <span>
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.HealthcareReceivedDetails"
                        )}
                      </span>
                    </h2>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.byWhom"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="healthcareName"
                            value={state.healthcareName.value}
                            onChange={handleChanges}
                            ref={state.healthcareName.ref}
                            className="form-control"
                          />
                          {state.healthcareName?.error && (
                            <span className="error">{state.healthcareName.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcarePhone"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={PHONE_PLACEHOLDER}
                            name="healthcarePhone"
                            value={state.healthcarePhone.value}
                            onChange={handlePhoneNumber}
                            ref={state.healthcarePhone.ref}
                            maxLength="14"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group Date-feild">
                          <label htmlFor="" className="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.Dateofmedicaltreatment"
                            )}
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>

                          <CustomDatePicker
                            id="dateOfMedicalTretmenet"
                            selected={state.dateOfMedicalTretmenet.value}
                            onChange={(e) => {
                              onDateChange(e, "dateOfMedicalTretmenet");
                            }}
                            maxDate={moment().toDate()}
                            className="form-control"
                            placeholderText={props.context.t(
                              "AIR-Employer-Information.form.common.DateFormat"
                            )}
                            name="dateOfMedicalTretmenet"
                            ref={state.dateOfMedicalTretmenet.ref}
                          />

                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcareAddress1"
                            )}
                          </label>
                          <textarea
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="healthcareAddress1"
                            value={state.healthcareAddress1.value}
                            onChange={handleChanges}
                            ref={state.healthcareAddress1.ref}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcareAddress2"
                            )}
                          </label>
                          <textarea
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="healthcareAddress2"
                            value={state.healthcareAddress2.value}
                            onChange={handleChanges}
                            ref={state.healthcareAddress2.ref}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">

                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcareCity"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="healthcareCity"
                            value={state.healthcareCity.value}
                            ref={state.healthcareCity.ref}
                            onChange={handleChanges}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcareProvince"
                            )}
                          </label>
                          <DropdownComponent
                            name="healthcareProvince"

                            isMultiSelect={false}
                            options={props.state}
                            option_key="provinceId"
                            option_display="province"
                            onChange={onDropDownChange}
                            values={state.healthcareProvince.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.healthcareProvince.ref}
                          />
                        </div>
                      </div>
                      {/* <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HealthcareCountry"
                            )}
                          </label>
                          <DropdownComponent
                            name="healthcareCountry"
                            options={COUNTRYDRPDATA}
                            isMultiSelect={false}
                            option_key="countryName"
                            option_display="countryName"
                            onChange={onDropDownChange}
                            values={state.healthcareCountry.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.healthcareCountry.ref}
                          />
                        </div>
                      </div> */}
                    </div>
                  </div>
                }




                {state.didHealthcareReceived.value == "Yes" &&
                  <div>
                    <h2 className="Sub-Heading">
                      <span>
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.FacilityTreatedDetails"
                        )}
                      </span>
                    </h2>

                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedName"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="facilityTreatedName"
                            value={state.facilityTreatedName.value}
                            onChange={handleChanges}
                            ref={state.facilityTreatedName.ref}
                            className="form-control"
                          />
                          {state.facilityTreatedName?.error && (
                            <span className="error">{state.facilityTreatedName.error}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedPhone"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={PHONE_PLACEHOLDER}
                            name="facilityTreatedPhone"
                            value={state.facilityTreatedPhone.value}
                            onChange={handlePhoneNumber}
                            ref={state.facilityTreatedPhone.ref}
                            maxLength="14"
                            className="form-control"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedAddress1"
                            )}
                          </label>
                          <textarea
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="facilityTreatedAddress1"
                            value={state.facilityTreatedAddress1.value}
                            onChange={handleChanges}
                            ref={state.facilityTreatedAddress1.ref}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedAddress2"
                            )}
                          </label>
                          <textarea
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="facilityTreatedAddress2"
                            value={state.facilityTreatedAddress2.value}
                            onChange={handleChanges}
                            ref={state.facilityTreatedAddress2.ref}
                            className="form-control"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedCity"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="facilityTreatedCity"
                            value={state.facilityTreatedCity.value}
                            ref={state.facilityTreatedCity.ref}
                            onChange={handleChanges}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedProvince"
                            )}
                          </label>
                          <DropdownComponent
                            name="facilityTreatedProvince"
                            options={props.state}
                            option_key="provinceId"
                            option_display="province"
                            isMultiSelect={false}

                            onChange={onDropDownChange}
                            values={state.facilityTreatedProvince.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.facilityTreatedProvince.ref}
                          />
                        </div>
                      </div>
                      {/* <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.FacilityTreatedCountry"
                            )}
                          </label>
                          <DropdownComponent
                            name="facilityTreatedCountry"
                            options={COUNTRYDRPDATA}
                            isMultiSelect={false}
                            option_key="countryName"
                            option_display="countryName"
                            onChange={onDropDownChange}
                            values={state.facilityTreatedCountry.value}
                            simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                            selectAllText="Select All Options"
                            isSearchOption={true}
                            searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            ref={state.facilityTreatedCountry.ref}
                          />
                        </div>
                      </div> */}
                    </div>


                    <div className="row">

                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group Ctm-rdo d-block">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.TreatedInHospitalOrEmergency"
                            )}
                          </label>
                          <div className="Radio-box" data-toggle="buttons">
                            <div className="check-col">
                              <input
                                type="radio"
                                name="treantedInHospital"
                                id="treantedInHospital-Hospital"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="Hospital"
                                checked={
                                  state.treantedInHospital.value === "Hospital"
                                }
                              />
                              <label htmlFor="treantedInHospital-Hospital">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.TreatedInHospitalOrEmergency.Hospital"
                                )}
                              </label>
                            </div>
                            <div className="check-col">
                              <input
                                type="radio"
                                name="treantedInHospital"
                                id="treantedInHospital-Emergency"
                                autoComplete="off"
                                onChange={handleChanges}
                                value="Emergency Room"
                                checked={
                                  state.treantedInHospital.value === "Emergency Room"
                                }
                              />
                              <label htmlFor="treantedInHospital-Emergency">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.TreatedInHospitalOrEmergency.Emergency"
                                )}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group Date-feild">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.Dateemployeereceivedmedicalattention"
                            )}
                            {props.context.t("AIR-Employer-Information.form.common.DateFormat")}
                          </label>
                          <CustomDatePicker
                            id="dateOfEmployerAboutMedicalTretmenet"
                            selected={
                              state.dateOfEmployerAboutMedicalTretmenet.value && state.dateOfEmployerAboutMedicalTretmenet.value
                            }
                            maxDate={moment().toDate()}
                            onChange={(e) => {
                              onDateChange(
                                e,
                                "dateOfEmployerAboutMedicalTretmenet"
                              );
                            }}
                            ref={state.dateOfEmployerAboutMedicalTretmenet.ref}
                            className="form-control"
                            placeholderText={props.context.t(
                              "AIR-Employer-Information.form.common.DateFormat"
                            )}
                          />
                          {state.dateOfEmployerAboutMedicalTretmenet?.error && (
                            <span className="error">
                              {state.dateOfEmployerAboutMedicalTretmenet.error}
                            </span>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                }
                <div className="row">

                  <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                    <div className="form-group Ctm-rdo d-block">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Information.form.label.text.HasCommiteeNotified"
                        )}
                      </label>
                      <div className="Radio-box" data-toggle="buttons">
                        <div className="check-col">
                          <input
                            type="radio"
                            name="hasCommiteeNotified"
                            id="hasCommiteeNotified-Yes"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="Yes"
                            checked={
                              state.hasCommiteeNotified.value === "Yes"
                            }
                          />
                          <label htmlFor="hasCommiteeNotified-Yes">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HasCommiteeNotified.Yes"
                            )}
                          </label>
                        </div>
                        <div className="check-col">
                          <input
                            type="radio"
                            name="hasCommiteeNotified"
                            id="hasCommiteeNotified-No"
                            autoComplete="off"
                            onChange={handleChanges}
                            value="No"
                            checked={
                              state.hasCommiteeNotified.value === "No"
                            }
                          />
                          <label htmlFor="hasCommiteeNotified-No">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.HasCommiteeNotified.No"
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group Ctm-rdo">
                      <label htmlFor="">
                        {props.context.t(
                          "AIR-Accident-Details.form.label.text.witnesses"
                        )}
                      </label>
                      <ToggleComponent
                        name="wereThereAnyWitness"
                        isActive={state.wereThereAnyWitness.value}
                        negativeValueTobeCompare="No"
                        positiveValueTobeCompare="Yes"
                        positiveValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                        )}
                        negativeValueTobeDisplay={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                        )}
                        handleChanges={handleQuestionChange}
                      />
                    </div>
                  </div>
                </div>
                {state.wereThereAnyWitness.value == "Yes" &&
                  <>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.WitnessName"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="witnessName"
                            value={state.witnessName.value}
                            onChange={handleChanges}
                            ref={state.witnessName.ref}
                            className="form-control"
                          />
                        </div>
                        {state.witnessName?.error && (
                          <span className="error">
                            {state.witnessName.error}
                          </span>
                        )}
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.WitnessPostion"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                            )}
                            name="witnessPosition"
                            value={state.witnessPosition.value}
                            onChange={handleChanges}
                            ref={state.witnessPosition.ref}
                            className="form-control"
                          />
                        </div>
                        {state.witnessPosition?.error && (
                          <span className="error">
                            {state.witnessPosition.error}
                          </span>
                        )}
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                        <div className="form-group">
                          <label htmlFor="">
                            {props.context.t(
                              "AIR-Accident-Information.form.label.text.WitnessesWorkPhone"
                            )}
                          </label>
                          <input
                            type="text"
                            placeholder={PHONE_PLACEHOLDER}
                            name="witnessWorkPhone"
                            value={state.witnessWorkPhone.value}
                            onChange={handlePhoneNumber}
                            ref={state.witnessWorkPhone.ref}
                            maxLength="14"
                            className="form-control"
                          />
                        </div>
                        {state.witnessWorkPhone?.error && (
                          <span className="error">
                            {state.witnessWorkPhone.error}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="form-group">
                          <textarea
                            type="text"
                            className="form-control"
                            placeholder={props.context.t(
                              "STD-Employer-Statement.form.subheading8.text"
                            )}
                            // "Additional Information"
                            name="witnessAdditionalInfo"
                            value={state.witnessAdditionalInfo.value}
                            onChange={handleChanges}
                          />
                          {state.witnessAdditionalInfo?.error && (
                            <span className="error">
                              {state.witnessAdditionalInfo.error}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>

                }

                <h2 className="Sub-Heading">
                  <span>
                    {props.context.t(
                      "AIR-Accident-Information.form.label.text.Title3"
                    )}
                  </span>
                </h2>

                {accidentInvestigationQuestion?.map((question) => (
                  <div key={question.questionNo} className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="form-group Ctm-rdo">
                        <label htmlFor="">
                          {props.context.t(question.question)}
                        </label>
                        <ToggleComponent
                          name={question.name}
                          isActive={state[question.name].value}
                          negativeValueTobeCompare="No"
                          positiveValueTobeCompare="Yes"
                          positiveValueTobeDisplay={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
                          )}
                          negativeValueTobeDisplay={props.context.t(
                            "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
                          )}
                          handleChanges={handleQuestionChange}
                        />
                      </div>
                      <div>
                        {(question.name != "accidentQues1" && question.name != "accidentQues10" && question.name != "accidentQues2" &&
                          question.name != "accidentQues3" && question.name != "accidentQues5" && question.name != "accidentQues6"
                          && question.name != "accidentQues8" && question.name != "accidentQues11") && state[question.name].value === "Yes" ? (
                          <div>
                            <div className="form-group">
                              <input
                                type="text"
                                placeholder={props.context.t(
                                  "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                )}
                                className="form-control"
                                name={question.commentFieldName}
                                ref={state[question.commentFieldName].ref}
                                value={state[question.commentFieldName].value}
                                onChange={handleChanges}
                              />
                            </div>
                            {state[question.commentFieldName]?.error && (
                              <span className="error">
                                {state[question.commentFieldName].error}
                              </span>
                            )}
                          </div>
                        ) : null}
                      </div>

                      {question.name == "accidentQues1" && state[question.name].value === "Yes" &&
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="form-group">

                              <div className="Radio-box" data-toggle="buttons">
                                <div className="check-col">
                                  <input
                                    type="radio"
                                    name="accidentQues1Comment"
                                    id="executive"
                                    autoComplete="off"
                                    onChange={handleChanges}
                                    value="Executive"
                                    checked={state.accidentQues1Comment.value === "Executive"}
                                  />
                                  <label htmlFor="executive">
                                    Executive
                                  </label>
                                </div>
                                <div className="check-col">
                                  <input
                                    type="radio"
                                    name="accidentQues1Comment"
                                    id="ElectedOfficial"
                                    autoComplete="off"
                                    onChange={handleChanges}
                                    value="Elected Official"
                                    checked={state.accidentQues1Comment.value === "Elected Official"}
                                  />
                                  <label htmlFor="ElectedOfficial">
                                    Elected Official
                                  </label>
                                </div>
                                <div className="check-col">
                                  <input
                                    type="radio"
                                    name="accidentQues1Comment"
                                    id="Owner"
                                    autoComplete="off"
                                    onChange={handleChanges}
                                    value="Owner"
                                    checked={state.accidentQues1Comment.value === "Owner"}
                                  />
                                  <label htmlFor="Owner">
                                    Owner
                                  </label>
                                </div>
                                <div className="check-col">
                                  <input
                                    type="radio"
                                    name="accidentQues1Comment"
                                    id="SpouseRelativeoftheEmployer"
                                    autoComplete="off"
                                    onChange={handleChanges}
                                    value="Spouse/Relative of the Employer"
                                    checked={state.accidentQues1Comment.value === "Spouse/Relative of the Employer"}
                                  />
                                  <label htmlFor="SpouseRelativeoftheEmployer">
                                    Spouse/Relative of the Employer
                                  </label>
                                </div>
                                <div className="check-col">
                                  <input
                                    type="radio"
                                    name="accidentQues1Comment"
                                    id="Subcontractor"
                                    autoComplete="off"
                                    onChange={handleChanges}
                                    value="Sub-contractor"
                                    checked={state.accidentQues1Comment.value === "Sub-contractor"}
                                  />
                                  <label htmlFor="Subcontractor">
                                    Sub-contractor
                                  </label>
                                </div>
                              </div>
                            </div>

                          </div>

                        </div>
                      }

                      {question.name == "accidentQues2" && state[question.name].value === "Yes" &&
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.OutsideCity"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={props.context.t(
                                  "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                )}
                                name="outsideCity"
                                value={state.outsideCity.value}
                                ref={state.outsideCity.ref}
                                onChange={handleChanges}
                                className="form-control"
                              />
                            </div>
                            {state.outsideCity?.error && (
                              <span className="error">
                                {state.outsideCity.error}
                              </span>
                            )}
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.OutsideProvice"
                                )}
                              </label>
                              <DropdownComponent
                                name="outsideProvince"
                                options={props.state}
                                option_key="provinceId"
                                option_display="province"
                                isMultiSelect={false}

                                onChange={onDropDownChange}
                                values={state.outsideProvince.value}
                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                selectAllText="Select All Options"
                                isSearchOption={true}
                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                ref={state.outsideProvince.ref}
                              />
                            </div>
                            {state.outsideProvince?.error && (
                              <span className="error">
                                {state.outsideProvince.error}
                              </span>
                            )}
                          </div>
                          <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.OutsideCountry"
                                )}
                              </label>
                              <DropdownComponent
                                name="outsideCountry"
                                options={COUNTRYDRPDATA}
                                isMultiSelect={false}
                                option_key="countryName"
                                option_display="countryName"
                                onChange={onDropDownChange}
                                values={state.outsideCountry.value}
                                simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                                selectAllText="Select All Options"
                                isSearchOption={true}
                                searchPlaceholder="STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                ref={state.outsideCountry.ref}
                              />
                            </div>
                            {state.outsideCountry?.error && (
                              <span className="error">
                                {state.outsideCountry.error}
                              </span>
                            )}
                          </div>
                        </div>
                      }

                      {question.name == "accidentQues3" && state[question.name].value === "Yes" &&
                        <div className="row">

                          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.ResponsibleName"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={props.context.t(
                                  "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                )}
                                name="responsibleName"
                                value={state.responsibleName.value}
                                ref={state.responsibleName.ref}
                                onChange={handleChanges}
                                className="form-control"
                              />
                            </div>
                            {state.responsibleName?.error && (
                              <span className="error">
                                {state.responsibleName.error}
                              </span>
                            )}
                          </div>

                          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.ResponsiblePhone"
                                )}
                              </label>
                              <input
                                type="text"
                                placeholder={PHONE_PLACEHOLDER}
                                name="responsiblePhone"
                                value={state.responsiblePhone.value}
                                onChange={handlePhoneNumber}
                                ref={state.responsiblePhone.ref}
                                maxLength="14"
                                className="form-control"
                              />
                            </div>
                            {state.responsiblePhone?.error && (
                              <span className="error">
                                {state.responsiblePhone.error}
                              </span>
                            )}
                          </div>
                        </div>
                      }


                      {question.name == "accidentQues11" && state[question.name].value === "Yes" &&

                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-6 col-lg-12">
                            <div className="form-group">
                              <label htmlFor="">
                                {props.context.t(
                                  "AIR-Accident-Information.form.label.text.specifyCompanyPremises"
                                )}
                                {/* <span size="5" className="error-star">
                          *
                        </span> */}
                              </label>
                              <textarea
                                type="textarea"
                                placeholder={props.context.t(
                                  "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                                )}
                                name="specifyCompanyPremices"
                                ref={state.specifyCompanyPremices.ref}
                                value={state.specifyCompanyPremices.value}
                                onChange={handleChanges}
                                className="form-control"
                              />
                            </div>
                            {state.specifyCompanyPremices?.error && (
                              <span className="error">
                                {state.specifyCompanyPremices.error}
                              </span>
                            )}
                          </div>
                        </div>
                      }


                    </div>

                  </div>
                ))}

                <div className="panel-footer text-right margn-50">
                  <a
                    tabIndex="0"
                    onClick={() => onSubmit(false, false)}
                    className="btn btn-blue"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-for-later.title"
                    )}
                  </a>
                  <a
                    tabIndex="0"
                    onClick={onSubmit}
                    className="btn btn-primary margin-left-5"
                  >
                    {props.context.t(
                      "AIR-Employer-Information.form.button.save-and-move-next-step.title"
                    )}
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AccidentInformation;
